/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 15:10:31
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/Text.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Text,
  //   ProductGridDisplay,
  Text,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const TextFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnTextStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };
  return {
    handleOnTextStaticChange,
    //  handleOnTextModuleTypeChange,
  };
};
const generateText = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  disabled,
  allDisabled,
}) => {
  const { handleOnTextStaticChange } = TextFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: Text,
    props: {
      onStaticChange: handleOnTextStaticChange,
      disabled,
      allDisabled,
    },
  };
};
export { generateText };
